import { Button } from "@mui/material";
import styles from "./style.module.css";
import { Filtro } from "../filtro";

export function Abas() {
  return(
    <div className={styles.header_table}>
      <div className={styles.buttons_pages_container}>
        <Button
          onClick={() => {}}
          disabled={true}
        >
          Dashboard
        </Button>
        <Button
          onClick={() => {}}
          disabled={false}
        >
          Feedback
        </Button>
      </div>

      <div>
        <Filtro/>
      </div>
    </div>
  )
}